export interface Comic {
  id: number
  title: string
  author: string
  cover: string
  category: string
  categorySlug: string
  rating: number
  status: '连载中' | '已完结'
  isHot: boolean
  isNew: boolean
  isRising: boolean
  description: string
  updateInfo: string
  chapters: number
  views: string
  tags: string[]
}

export const comics: Comic[] = [
  {
    id: 1,
    title: '她的私密恋爱',
    author: '朴智敏',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%20style%2C%20soft%20pink%20atmosphere%2C%20young%20couple%20facing%20each%20other%20with%20cherry%20blossom%20petals%2C%20delicate%20lineart%20digital%20illustration%2C%20clean%20composition%20on%20white%20background%2C%20minimal%20design%2C%20pastel%20color%20palette%2C%20shoujo%20manga%20inspired%20art%20style&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    category: '浪漫爱情',
    categorySlug: 'romance',
    rating: 4.8,
    status: '连载中',
    isHot: true,
    isNew: false,
    isRising: false,
    description: '平凡上班族李智恩偶然遇见顶头上司的秘密恋情，在一次又一次的偶遇中，两人的关系逐渐升温。办公室里的隐秘心动，下班后的甜蜜约会，这是一段关于勇气与真爱的浪漫故事。',
    updateInfo: '更新至第 87 话',
    chapters: 87,
    views: '3280万',
    tags: ['办公室', '甜蜜', '年上'],
  },
  {
    id: 2,
    title: '剑魂觉醒',
    author: '金尚勋',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20action%20manhwa%20cover%2C%20warrior%20holding%20glowing%20sword%2C%20dynamic%20pose%2C%20dramatic%20lighting%20with%20dark%20background%2C%20epic%20fantasy%20illustration%20style%2C%20orange%20and%20red%20energy%20effects%2C%20detailed%20armor%20design%2C%20clean%20digital%20art%2C%20professional%20manga%20style&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    category: '热血动作',
    categorySlug: 'action',
    rating: 4.9,
    status: '连载中',
    isHot: true,
    isNew: false,
    isRising: true,
    description: '废柴少年秦风意外获得上古剑魂传承，从此踏上修炼之路。面对重重强敌，他以不屈意志突破境界，一路逆袭成为最强剑修。热血战斗，燃情升级！',
    updateInfo: '更新至第 156 话',
    chapters: 156,
    views: '5820万',
    tags: ['修炼', '逆袭', '热血'],
  },
  {
    id: 3,
    title: '异界魔法学院',
    author: '李恩秀',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20cover%2C%20magic%20academy%20student%20with%20glowing%20spellbook%2C%20mystical%20blue%20atmosphere%2C%20floating%20crystals%20and%20magic%20circles%2C%20fantasy%20illustration%20style%2C%20clean%20digital%20art%2C%20stained%20glass%20window%20background%2C%20elegant%20character%20design&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    category: '奇幻冒险',
    categorySlug: 'fantasy',
    rating: 4.7,
    status: '连载中',
    isHot: true,
    isNew: false,
    isRising: false,
    description: '普通高中生林雨被神秘魔法阵传送到异世界魔法学院，在这里她发现自己是预言中的传奇魔法师。与各色伙伴一起学习魔法、解开谜团，一场宏大的冒险就此展开。',
    updateInfo: '更新至第 203 话',
    chapters: 203,
    views: '4560万',
    tags: ['魔法', '学院', '异世界'],
  },
  {
    id: 4,
    title: '月光下的你',
    author: '崔允熙',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20BL%20manhwa%20cover%20style%2C%20two%20young%20men%20standing%20under%20moonlight%2C%20gentle%20atmosphere%2C%20soft%20blue%20and%20silver%20color%20palette%2C%20romantic%20night%20scene%2C%20delicate%20lineart%2C%20minimal%20design%2C%20clean%20composition%20on%20dark%20background%2C%20emotional%20expression&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    category: 'BL专区',
    categorySlug: 'bl',
    rating: 4.6,
    status: '已完结',
    isHot: false,
    isNew: false,
    isRising: false,
    description: '在同一所大学里，音乐系的韩俊和美术系的尹夏因一次偶然合作相识。两个性格迥异的年轻人，在月光下的天台相遇，悄然展开了一段治愈心灵的温暖故事。',
    updateInfo: '全 72 话已完结',
    chapters: 72,
    views: '2150万',
    tags: ['校园', '治愈', '音乐'],
  },
  {
    id: 5,
    title: '密室逃脱',
    author: '姜道贤',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20thriller%20manhwa%20cover%2C%20mysterious%20locked%20room%20with%20dim%20lighting%2C%20shadow%20figure%20in%20background%2C%20dark%20atmosphere%20with%20red%20accents%2C%20suspenseful%20digital%20illustration%2C%20clean%20composition%2C%20psychological%20horror%20style%2C%20minimal%20but%20intense%20design&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    category: '悬疑惊悚',
    categorySlug: 'thriller',
    rating: 4.5,
    status: '连载中',
    isHot: false,
    isNew: true,
    isRising: false,
    description: '六个陌生人在一间密室中醒来，谁都不记得自己是如何来到这里的。随着一道道谜题被解开，他们发现彼此之间隐藏着不为人知的秘密联系。真相大白之时，才是真正的恐惧开始。',
    updateInfo: '更新至第 34 话',
    chapters: 34,
    views: '980万',
    tags: ['推理', '密室', '反转'],
  },
  {
    id: 6,
    title: '首尔物语',
    author: '韩素英',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20drama%20manhwa%20cover%2C%20modern%20Seoul%20cityscape%20background%2C%20young%20woman%20in%20coffee%20shop%2C%20warm%20natural%20lighting%2C%20slice%20of%20life%20aesthetic%2C%20realistic%20digital%20illustration%2C%20soft%20brown%20and%20cream%20tones%2C%20minimal%20design%2C%20calm%20atmosphere&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    category: '都市剧情',
    categorySlug: 'drama',
    rating: 4.4,
    status: '连载中',
    isHot: false,
    isNew: false,
    isRising: false,
    description: '讲述了在首尔这座城市中，四个不同年龄、不同职业的女性各自面对的生活困境与成长蜕变。职场压力、情感纠葛、家庭矛盾，她们在彼此的支持下找到了前行的力量。',
    updateInfo: '更新至第 118 话',
    chapters: 118,
    views: '1860万',
    tags: ['职场', '女性', '成长'],
  },
  {
    id: 7,
    title: '前世今生缘',
    author: '张美兰',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20historical%20fantasy%20manhwa%20cover%2C%20traditional%20hanbok%20couple%20in%20ancient%20palace%20garden%2C%20cherry%20blossom%20trees%2C%20soft%20golden%20lighting%2C%20romantic%20historical%20atmosphere%2C%20delicate%20digital%20illustration%2C%20elegant%20style%2C%20clean%20composition&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    category: '古风历史',
    categorySlug: 'historical',
    rating: 4.7,
    status: '已完结',
    isHot: false,
    isNew: false,
    isRising: true,
    description: '现代女孩苏瑶意外穿越到朝鲜王朝，成为一名宫女。在这里她遇到了与前世恋人容貌相同的世子。两人在宫廷斗争中相互扶持，展开了一段跨越时空的宿命之恋。',
    updateInfo: '全 98 话已完结',
    chapters: 98,
    views: '3120万',
    tags: ['穿越', '宫廷', '宿命'],
  },
  {
    id: 8,
    title: '笨蛋情侣日常',
    author: '宋智浩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20comedy%20manhwa%20cover%2C%20funny%20couple%20with%20exaggerated%20expressions%2C%20bright%20colorful%20background%2C%20playful%20and%20cute%20art%20style%2C%20chibi%20style%20characters%2C%20yellow%20and%20pink%20tones%2C%20clean%20digital%20illustration%2C%20humorous%20design&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    category: '搞笑日常',
    categorySlug: 'comedy',
    rating: 4.3,
    status: '连载中',
    isHot: false,
    isNew: false,
    isRising: false,
    description: '一对刚同居的年轻情侣，每天都在上演各种令人捧腹的日常趣事。从做饭失败到约会迷路，两人的搞笑互动让人忍不住嘴角上扬。轻松治愈的恋爱喜剧！',
    updateInfo: '更新至第 56 话',
    chapters: 56,
    views: '1670万',
    tags: ['搞笑', '恋爱', '日常'],
  },
  {
    id: 9,
    title: '黑帮之王',
    author: '赵振宇',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20action%20manhwa%20cover%2C%20man%20in%20black%20suit%20with%20intense%20expression%2C%20dark%20urban%20night%20background%2C%20neon%20signs%2C%20noir%20atmosphere%2C%20dramatic%20lighting%2C%20clean%20digital%20art%2C%20professional%20illustration%20style%2C%20dark%20blue%20and%20crimson%20tones&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    category: '热血动作',
    categorySlug: 'action',
    rating: 4.8,
    status: '连载中',
    isHot: false,
    isNew: true,
    isRising: false,
    description: '退役特种兵韩真宇为保护家人被迫踏入黑道世界。凭借过人的战斗技巧与冷静头脑，他一路披荆斩棘，在血与火的淬炼中成为地下世界的传奇。',
    updateInfo: '更新至第 189 话',
    chapters: 189,
    views: '4980万',
    tags: ['黑道', '格斗', '复仇'],
  },
  {
    id: 10,
    title: '初恋补习班',
    author: '李在恩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20school%20romance%20manhwa%20cover%2C%20two%20high%20school%20students%20in%20classroom%2C%20sunlight%20streaming%20through%20window%2C%20warm%20atmosphere%2C%20youthful%20innocent%20style%2C%20pastel%20color%20palette%2C%20clean%20digital%20illustration%2C%20soft%20shoujo%20aesthetic&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    category: '校园青春',
    categorySlug: 'school',
    rating: 4.5,
    status: '连载中',
    isHot: false,
    isNew: false,
    isRising: false,
    description: '学霸班长金智秀被老师安排给全校倒数第一的转学生补习功课。从互相看不顺眼到暗生情愫，两人的关系在学习与成长中悄然改变。青涩可爱的校园初恋故事。',
    updateInfo: '更新至第 63 话',
    chapters: 63,
    views: '1450万',
    tags: ['校园', '学霸', '初恋'],
  },
  {
    id: 11,
    title: '猫咪咖啡馆',
    author: '郑多惠',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20slice%20of%20life%20manhwa%20cover%2C%20cozy%20cat%20cafe%20interior%2C%20young%20woman%20holding%20a%20cat%2C%20warm%20afternoon%20light%2C%20soft%20cream%20and%20beige%20tones%2C%20comforting%20atmosphere%2C%20clean%20digital%20illustration%2C%20healing%20vibes%2C%20minimal%20design&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    category: '治愈生活',
    categorySlug: 'slice-of-life',
    rating: 4.6,
    status: '连载中',
    isHot: false,
    isNew: false,
    isRising: false,
    description: '辞去高压工作的允儿接手了一家即将倒闭的猫咪咖啡馆。在这里她遇到了形形色色的客人和可爱的猫咪们，也在治愈他人的过程中找回了生活的意义与快乐。',
    updateInfo: '更新至第 41 话',
    chapters: 41,
    views: '890万',
    tags: ['猫咪', '治愈', '美食'],
  },
  {
    id: 12,
    title: '双面人生',
    author: '朴泰俊',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20psychological%20thriller%20manhwa%20cover%2C%20split%20face%20portrait%20with%20light%20and%20dark%20sides%2C%20mirror%20reflection%2C%20tense%20atmosphere%2C%20black%20and%20white%20with%20red%20accent%2C%20clean%20digital%20art%2C%20dramatic%20composition%2C%20mysterious%20mood&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    category: '悬疑惊悚',
    categorySlug: 'thriller',
    rating: 4.4,
    status: '已完结',
    isHot: false,
    isNew: false,
    isRising: false,
    description: '表面温和的心理咨询师，实则是连环案件的幕后推手。当警方一步步逼近真相时，他的双重身份究竟能维持多久？一场扣人心弦的心理博弈。',
    updateInfo: '全 55 话已完结',
    chapters: 55,
    views: '1230万',
    tags: ['心理', '犯罪', '悬疑'],
  },
]

export const featuredComic = comics[1]

export const editorPickComic = comics[0]

export const hotComics = comics.slice(0, 6)

export const newComics = comics.filter(c => c.isNew)

export const risingComics = comics.filter(c => c.isRising)

export function getComicById(id: number): Comic | undefined {
  return comics.find(c => c.id === id)
}

export function getComicsByCategory(slug: string): Comic[] {
  return comics.filter(c => c.categorySlug === slug)
}

export function getRelatedComics(comic: Comic, count: number = 4): Comic[] {
  return comics
    .filter(c => c.id !== comic.id && c.categorySlug === comic.categorySlug)
    .slice(0, count)
}